// extracted by mini-css-extract-plugin
export default {"title":"KgUrj___Buildings-module__title","cardList":"ls5tc___Buildings-module__cardList"};